import { type ValueOf, type PluginDefinition, type PluginWebInfo, type PluginRegistration } from "@saludio/core";

export type { PluginDefinition as PluginBaseInfo };

export type PageIdentifier = PluginDefinition["id"] | "settings";
export const PluginStatusSet = {
  DISABLED: "disabled",
  FAILED: "failed",
  LOADED: "loaded",
  LOADING: "loading",
} as const;
export type PluginStatus = ValueOf<typeof PluginStatusSet>;

export type PluginEntry = PluginDefinition & {
    registration?: PluginRegistration;
    webInfo?: PluginWebInfo;
    status: PluginStatus;
  };

export type LoadPluginCallbacks = {
  onSlotsResolved: (slots: PluginDefinition[]) => void;
  onPluginLoaded: (plugin: PluginEntry) => void;
  onPluginDisabled: (pluginId: string) => void;
  onPluginFailed: (pluginId: string, error: Error) => void;
};
